import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, ShieldCheck, LogOut, Home, CalendarRange, Star, Wallet, FileText, Tag, Wallet2, Palette, Users, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const navItems = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "admin-nav-dashboard" },
  { to: "/admin/properties", label: "Moderasi Properti", icon: ShieldCheck, testid: "admin-nav-moderation" },
  { to: "/admin/bookings", label: "Booking", icon: CalendarRange, testid: "admin-nav-bookings" },
  { to: "/admin/promos", label: "Promo", icon: Tag, testid: "admin-nav-promos" },
  { to: "/admin/commissions", label: "Komisi", icon: Wallet2, testid: "admin-nav-commissions" },
  { to: "/admin/refunds", label: "Refund", icon: Wallet, testid: "admin-nav-refunds" },
  { to: "/admin/agreements", label: "Kontrak", icon: FileText, testid: "admin-nav-agreements" },
  { to: "/admin/reviews", label: "Ulasan", icon: Star, testid: "admin-nav-reviews" },
  { to: "/admin/cms", label: "CMS / Website", icon: Palette, testid: "admin-nav-cms" },
  { to: "/admin/admins", label: "Kelola Admin", icon: Users, testid: "admin-nav-admins" },
  { to: "/admin/accounts", label: "Kelola Akun", icon: Users, testid: "admin-nav-accounts" },
  { to: "/admin/subscription", label: "Subscription", icon: ShieldCheck, testid: "admin-nav-subscription" },
  { to: "/pengaturan-akun", label: "Keamanan Akun", icon: Lock, testid: "admin-nav-security" },
];

export default function AdminLayout({ children, testid = "admin-shell" }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid={testid}>
      <div className="flex flex-col lg:flex-row gap-8">
        <aside className="lg:w-64 shrink-0">
          <div className="bg-card border border-border rounded-2xl p-4 lg:sticky lg:top-24">
            <div className="flex items-center gap-2 px-2 pb-4 mb-2 border-b border-border">
              <span className="grid place-items-center w-8 h-8 rounded-lg bg-primary text-primary-foreground">
                <Home size={16} />
              </span>
              <div className="min-w-0">
                <p className="font-heading text-sm font-semibold leading-tight truncate">{user?.name || "Admin"}</p>
                <p className="text-xs text-muted-foreground">Admin Panel</p>
              </div>
            </div>
            <nav className="space-y-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  data-testid={item.testid}
                  className={({ isActive }) =>
                    `flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                      isActive ? "bg-secondary text-primary" : "text-muted-foreground hover:bg-secondary/60"
                    }`
                  }
                >
                  <item.icon size={16} /> {item.label}
                </NavLink>
              ))}
              <button
                onClick={handleLogout}
                data-testid="admin-nav-logout"
                className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium text-muted-foreground hover:bg-secondary/60 transition-colors"
              >
                <LogOut size={16} /> Logout
              </button>
            </nav>
          </div>
        </aside>

        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </div>
  );
}
